
export default [
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        hidden: true,
        children: [
            {path: "", redirect: "/meeting-list"},
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        meta: {mobile:true},
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        children: [
            {
                path: '/profile',
                component: () => import(/* webpackChunkName: "home" */ '../views/profile'),
                name: '我的档案'
            }
        ]
    },
    {
        path: '/',
        name: '会议查看',
        icon: 'el-icon-view',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        meta: {level: [4, 3]},
        children: [
            {
                path: '/meeting-list',
                icon: 'el-icon-s-order',
                component: () => import(/* webpackChunkName: "home" */ '../views/meeting-list'),
                name: '查看会议',
                meta: {friendly: '会议', level: [4, 3]}
            },
        ]
    },
    {
        path: '/admin',
        name: '后台管理',
        icon: 'el-icon-setting',
        component: () => import(/* webpackChunkName: "adminadmin" */ '../views/home.vue'),
        meta: {level: [4], wide: true},
        children: [
            {
                icon: 'el-icon-user',
                path: '/visitor',
                component: () => import(/* webpackChunkName: "adminadmin" */ '../views/admin-visitors'),
                name: '用户管理',
                meta: {friendly: '用户', model: 'Visitor', copy:true}
            },
            {
                icon: 'el-icon-star-on',
                path: '/tm-user',
                component: () => import(/* webpackChunkName: "room" */ '../views/admin-tm-user'),
                name: '腾讯用户',
                meta: {friendly: '用户', model: 'TMRoom', copy:true}
            },
            {
                icon: 'el-icon-files',
                path: '/department',
                component: () => import(/* webpackChunkName: "room" */ '../views/admin-department'),
                name: '部门管理',
                meta: {friendly: '部门', model: 'Department', copy:true}
            },
            {
                icon: 'el-icon-star-off',
                path: '/xjtlu-user',
                component: () => import(/* webpackChunkName: "room" */ '../views/admin-xjtlu-user'),
                name: '西郊用户',
                meta: {friendly: '用户', model: 'XjtluUser', copy:true}
            },
        ]
    },
    {
        path: '/system',
        name: '系统管理',
        icon: 'el-icon-set-up',
        component: () => import(/* webpackChunkName: "system" */ '../views/home.vue'),
        meta: {level: [4], wide: true},
        children: [
            {
                icon: 'el-icon-school',
                path: '/admin/tenant',
                meta:{friendly: '租户',model:'Tenant',copy:true},
                component: () => import(/* webpackChunkName: "system" */ '../views/admin-admin'),
                name: '租户管理',
            },
            {
                icon: 'el-icon-goods',
                path: '/admin/resource',
                meta:{friendly: '对接资源',model:'Resource'},
                component: () => import(/* webpackChunkName: "system" */ '../views/admin-admin'),
                name: '资源管理',
            },
            {
                icon: 'el-icon-s-operation',
                path: '/parameters',
                component: () => import(/* webpackChunkName: "system" */ '../views/admin-admin'),
                name: '参数管理',
                meta: {friendly: '参数', model: 'Parameter', copy: true}
            },
            {
                icon: 'el-icon-present',
                path: '/admin-scheduler',
                component: () => import(/* webpackChunkName: "system" */ '../views/admin-scheduler'),
                name: '调度日志',
                meta: {friendly: '日志', model: 'Scheduler',}
            },
            {
                icon: 'el-icon-key',
                path: '/admin-syslog',
                component: () => import(/* webpackChunkName: "system" */ '../views/admin-syslog'),
                name: '系统日志',
                meta: {friendly: '日志', model: 'Syslog',}
            },
        ]
    },
    {
        path: '/help',
        name: '帮助',
        icon: 'el-icon-notebook-2',
        component: () => import(/* webpackChunkName: "manual" */ '../views/home.vue'),
        meta: {level: [4], wide: true},
        children: [
            {
                icon: 'el-icon-notebook-2',
                path: '/manual/lti',
                component: () => import(/* webpackChunkName: "manual" */ '../views/manual-lti'),
                name: '对接手册',
                meta: {friendly: '对接手册', level: [4], wide: true}
            },
        ]
    },
    {
        path: '/report',
        name: '系统报表',
        icon: 'el-icon-data-line',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        meta: {wide: true},
        children: [
            {
                path: '/meeting-detail',
                component: () => import(/* webpackChunkName: "report" */ '../views/meeting-detail.vue'),
                name: '会议详情'
            },
            {
                path: '/meeting-participant',
                component: () => import(/* webpackChunkName: "report" */ '../views/admin-admin.vue'),
                name: '参会者',
                meta: {level: [4],model:'MeetingParticipant'}
            },

        ],
    }
]
